import { Component, Input, OnInit} from '@angular/core';
import { trigger, transition, style, animate} from '@angular/animations';
import {
  CalendarViewType,
  EventItem,
  EventItemType,
  EventStatus,
  League,
  LeagueEvents,
  Lookups,
  Sport
} from "@model";
import {AbstractComponent, FilterGroup, FilterGroupType, FilterItem} from "@components";
import {EVENT_CALENDAR_ROUTE, EVENT_DETAILS, PRIVATE_EVENT_CALENDAR_ROUTE} from "../../../../app-routing.module";
import {buildEventSlug} from "@utility";
import {ActivatedRoute, Router} from "@angular/router";
import {AuthenticationService} from "@services";

@Component({
  selector: 'app-league-event-list-tab',
  templateUrl: './league-event-list-tab.component.html',
  styleUrls: ['./league-event-list-tab.component.scss'],
  standalone: false,
  animations: [
  trigger('listState', [
    transition(':enter', [
      style({ opacity: 0 }),
      animate('300ms ease-in', style({ opacity: 1 }))
    ])
  ])
  ]
})
export class LeagueEventListTabComponent extends AbstractComponent implements OnInit {

  @Input() league?: League;
  @Input() leagueEvents?: LeagueEvents;
  @Input({required: true}) languages: Lookups[] = [];
  @Input() countries: Lookups[] = [];
  @Input() sports: Sport[] = [];
  filterGroups: FilterGroup[] = [];
  upcomingEvents: EventItem[] = [];
  completedEvents: EventItem[] = [];
  navigateEventIds = new Set<number>();
  activeEventStatus: EventStatus | undefined = undefined;

  constructor(private route: ActivatedRoute, private router: Router, public authenticationService: AuthenticationService,) {
    super();
  }

  ngOnInit(): void {
    this.navigateEventIds = new Set((this.leagueEvents?.events ?? []).map(e => e.id!));
    this.buildFilteringParams();
    this.setCompletedEvents();
    this.setUpcomingEvents();
  }


  goToEventDetailsPage(item: EventItem) {
    if (this.navigateEventIds.has(item.id!)) {
      const baseRoute = this.authenticationService.isAuthenticated()
          ? PRIVATE_EVENT_CALENDAR_ROUTE
          : EVENT_CALENDAR_ROUTE;

      const url = this.router.serializeUrl(
          this.router.createUrlTree([baseRoute, EVENT_DETAILS, buildEventSlug(item.id!, item)])
      );
      window.open(url, '_blank');
    }
  }

  onFilterChange(result: Record<string, any>) {
    const status: EventStatus | undefined = result['status'] ?? undefined;
    const searchTerm = result['searchTerm'] ?? undefined;
    const nameQ = searchTerm?.trim().toLowerCase();

    const matches = (e: EventItem): boolean => {
      if (nameQ) {
        const matchesName = [e.name, e.nameEng, e.nameIta, e.nameSlo, e.nameBs, e.nameSr]
            .some(n => n?.toLowerCase().includes(nameQ));
        if (!matchesName) return false;
      }
      return true;
    };

    const filterEvents = (events: EventItem[]): EventItem[] => {
      return events?.filter(matches) ?? [];
    };

    this.upcomingEvents = [];
    this.completedEvents = [];
    this.upcomingEvents = filterEvents(this.leagueEvents?.upcoming ?? []);
    this.completedEvents = filterEvents(this.leagueEvents?.finished ?? []);

    if (status !== this.activeEventStatus) {
      this.activeEventStatus = status;
    }
  }

  private buildFilteringParams() {
    this.filterGroups = [
      new FilterGroup('status', 'status', '',
          FilterGroupType.SINGLE_SELECT_BUTTONS,
          false,
          [
            new FilterItem(undefined,undefined, 'app.common.all', true),
            new FilterItem(EventStatus.ACTIVE,undefined, 'event.item.status.1', false),
            new FilterItem(EventStatus.FINISHED, undefined, 'event.item.status.2', false),
          ]),
    ];
  }

  setUpcomingEvents(): void {
    this.upcomingEvents = [...this.leagueEvents?.upcoming ?? []];
  }

  setCompletedEvents(): void {
    this.completedEvents = [...this.leagueEvents?.finished ?? []];
  }

  protected readonly EventItemType = EventItemType;
  protected readonly CalendarViewType = CalendarViewType;
  protected readonly EventStatus = EventStatus;
}